import { PublicClientApplication, type Configuration } from '@azure/msal-browser'
import type { AppConfig } from '../config'

// Builds the MSAL browser instance from runtime config. Tokens are held in
// session storage (cleared on browser close) — appropriate for an internal
// operator console. The console requests `apiScope` (the operator-console API
// scope exposed by the Licensing AAD app) so one token is accepted by both the
// Licensing and MINT Function Apps' Easy Auth (ATC-053).
export function buildMsalInstance(config: AppConfig): PublicClientApplication {
  const msalConfig: Configuration = {
    auth: {
      clientId: config.aadClientId,
      authority: config.aadAuthority,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
  }
  return new PublicClientApplication(msalConfig)
}

export function apiScopes(config: AppConfig): string[] {
  return [config.apiScope]
}
